<template>
  <div class="match">
    <loading-state :state="state"></loading-state>
    <div v-if="match">
      <div class="menu-title-right">
        <span v-if="match.matchOvers"> | {{ match.matchOvers }} overs</span>
        <span v-if="match.dl_applied"> | D/L</span>
        <span v-if="match.status.isStarted">
          <span v-if="match.format.isTest"> | Day {{ match.day }}</span>
          <span v-if="match.status_overview != 'in_play'"> | {{ match.status_overview | capitalise }}</span>
          <span v-else><span class="live-tag" :class="{'live-now': match.isLiveNow}">{{match.liveStatusText}}</span></span>
        </span>
        <span v-if="liveUpdateInited">
          <select class="clean" v-model="fetchMethod">
            <option
              v-for="method in fetchMethods"
              :key="method.key"
              :value="method.key">{{method.value}} <span v-if="method.isPull">{{pullFreq}}s</span></option>
          </select>
        </span>
      </div>
      <h2>{{match.name}}</h2>
      <match-live
        v-if="match.status.isStarted && match.batting_order && match.batting_order.length > 0"
        @playerSelected="onPlayerSelected"
        @ballSelected="onBallSelected"
        :match="match"
        :matchUserPref="matchUserPref"
        :isMetric="isMetric"
      ></match-live>
      <section class="fullwidth compact" v-if="!match.status.isNotStarted">
        <div class="part-first "><h5>
          <router-link
            class="clean"
            :to="{name:'cricketSeasonTeam', params:{key:match.season.key, teamkey:match.teams.a.match.season_team_key}}">
            {{match.teams.a.name}}</router-link> <span v-if="match.winner_team == 'a'">&starf;</span>
            </h5>
        </div>
        <div class="part-last "><h5>
          <router-link
            class="clean"
            :to="{name:'cricketSeasonTeam', params:{key:match.season.key, teamkey:match.teams.b.match.season_team_key}}">
            {{match.teams.b.name}}</router-link>
          <span v-if="match.winner_team == 'b'">&starf;</span>
          </h5>
        </div>
      </section>
      <section class="fullwidth" v-else-if="match.status.isNotStarted">
        <div class="center-title">
          <h2 class="info">{{match.start_at | relativeShortDateTime}}</h2>
        </div>
      </section>
      <section class="fullwidth" v-else>
        <div class="center-title">
          <h2 class="info">{{match.status_overview | capitalise}}</h2>
        </div>
      </section>
      <section class="fullwidth" v-if="match.status.isStarted && match.winning_ratio">
        <div class="part-first"><span v-if="match.winning_ratio.a > match.winning_ratio.b">&starf; </span>{{match.winning_ratio.a}}%</div>
        <div class="part-last">{{match.winning_ratio.b}}%<span v-if="match.winning_ratio.a < match.winning_ratio.b"> &starf;</span></div>
      </section>
      <section class="fullwidth" v-if="match.batting_order && match.batting_order.length">
        <div :class="[item[1]]" v-for="item in [
        ['a', 'part-first'],
        ['b', 'part-last'],]"
        :key="item.$index">
          <div v-for="(teamin, index) in match.batting_order" v-if="teamin[0] == item[0]" :key="index">
            <div class="highlight main">
              {{match.innings[teamin[0] + '_' + teamin[1]].runs}}/{{match.innings[teamin[0] + '_' + teamin[1]].wickets}}<sup
               v-if="match.isBattingInnings(teamin)">*</sup>
            </div>
            <div class="sub">
              <div>
                  <span class="silent" v-if="item[0] == 'a'" v-html="match.overPrefix(teamin)"></span>
                  {{match.formatOver(match.innings[teamin[0] + '_' + teamin[1]].overs)}} ov
                  <span class="silent" v-if="item[0] == 'b'" v-html="match.overPrefix(teamin)"></span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="sub-menu sticky" v-if="sections.length > 1">
        <ul>
          <li
            v-for="section in sections" :key="section.key"
            :class="{active: section.value == activeSection.value}"
            @click="activeSection = section">{{section.value | capitalise}}</li>
        </ul>
      </div>

      <div v-if="activeSection.isInfo">
        <section class="fullwidth col-center">
          <div class="acol bigger onbox">
            <h2 class="info">
              <router-link class="clean" :to="{name: isMetric ? 'MetricSeason' :'cricketSeason', params: {key: match.season.key}}">
                {{match.season.name}}
              </router-link>
            </h2>

            <div class="dl-box" v-if="match.msgs.info">
              <div>{{match.msgs.info}}</div>
            </div>

            <div class="dl-box big-dd">
              <dl>
                <dt>Start:</dt>
                <dd>{{match.start_at | relativeShortDateTime}}</dd>
                <dt>Format:</dt>
                <dd>{{match.format.key | capitalise}}
                  <span v-if="match.match_overs">({{match.match_overs}} overs)</span>
                </dd>
                <dt>Venue:</dt>
                <dd>{{match.venue}}</dd>
                <template v-if="match.toss && match.toss.won">
                  <dt>Toss:</dt>
                  <dd>{{match.teams[match.toss.won].name}} {{match.toss.decision | capitalise}} | {{match.toss.str}}</dd>
                </template>
                <dt>Status:</dt>
                <dd>{{match.data_review_checkpoint | capitalise('-')}}
                  | {{match.status_overview | capitalise('-')}}
                  | {{match.status.key}}</dd>
              </dl>
            </div>
          </div>
        </section>
        <section class="fullwidth col-center">
          <div class="acol bigger onbox" v-if="match.status.isCompleted">
            <h2 class="info">
              Result
            </h2>

            <div class="dl-box" v-if="match.msgs.completed">
              <div>{{match.msgs.completed}}</div>
            </div>

            <div class="dl-box big-dd">
              <dl>
                <template v-if="match.msgs.result">
                  <dt>Result:</dt>
                  <dd>{{match.msgs.result}}</dd>
                </template>

                <template v-if="match.winner_team">
                  <dt>Winner:</dt>
                  <dd>{{match.teams[match.winner_team].name}}</dd>
                </template>

                <template v-if="match.man_of_match">
                  <dt>POM:</dt>
                  <dd class="changing clickable" @click="onPlayerSelected(match.man_of_match)" >{{match.players[match.man_of_match].name}}</dd>
                </template>

                <template v-if="match.approxCompletedTime">
                  <dt>Completed:</dt>
                  <dd>{{match.approxCompletedTime | relativeShortDateTime}}</dd>
                </template>
                <template v-if="match.result_by">
                  <dt>Result By:</dt>
                  <dd>{{match.result_by | capitalise}}</dd>
                </template>

              </dl>
            </div>
          </div>
        </section>
        <section class="fullwidth col-center">
          <div class="acol bigger onbox">
            <p>{{match.long_description}}</p>
          </div>
        </section>
      </div>
      <cricket-match-team
        @playerSelected="onPlayerSelected"
        :match="match"
        v-if="activeSection.isTeam" :isMetric="isMetric"></cricket-match-team>

      <cricket-match-scorecard
        @playerSelected="onPlayerSelected"
        @ballSelected="onBallSelected"
        :match="match"
        :matchUserPref="matchUserPref"
        v-if="activeSection.isScorecard"></cricket-match-scorecard>

      <cricket-match-stats
        @playerSelected="onPlayerSelected"
        @ballSelected="onBallSelected"
        :match="match"
        :matchUserPref="matchUserPref"
        v-if="activeSection.isStats"></cricket-match-stats>

      <match-commentary
        @playerSelected="onPlayerSelected"
        @ballSelected="onBallSelected"
        :match="match"
        :matchUserPref="matchUserPref"
        v-if="activeSection.isCommentary"></match-commentary>

      <match-fantasy
        @playerSelected="onPlayerSelected"
        :match="match"
        v-if="activeSection.isFantasy"></match-fantasy>

      <!-- <fantasy-game
        :match="match"
        v-if="activeSection.isGame"></fantasy-game> -->

      <div class="app-right-dailog" :class="{visible: selectedPlayer != null}">
        <div class="tools"><button @click="selectedPlayer=null" class="box">Close</button></div>
        <div class="content"  v-if="selectedPlayer">
          <cricket-match-player
            :player="selectedPlayer"
            :match="match"
            @ballSelected="onBallSelected"></cricket-match-player>
        </div>
      </div>

      <div class="app-right-dailog" :class="{visible: selectedBall != null}">
        <div class="tools"><button @click="selectedBall=null" class="box">Close</button></div>
        <div class="content"  v-if="selectedBall">
          <cricket-match-ball :ball="selectedBall" :match="match"></cricket-match-ball>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Pull } from '@/models/pull'
import { CricketMatch } from '@/models/cricket/match'
import { SocketProxy } from '@/models/push'
import { CricketFirebase } from '@/models/firebase'
import { LocalUserPref } from '@/models/core'
import { DataState, AppState } from '@/state'
import AppEvents from '@/appevents'
import { Enum } from '@/helpers/enum'
import Vue from 'vue'

import MatchCommentary from '@/components/cricket/MatchCommentary.vue'
import MatchFantasy from '@/components/cricket/MatchFantasy.vue'
import MatchLive from '@/components/cricket/MatchLive.vue'
import Fantasy from '@/components/cricket/fantasy/Fantasy.vue'

export const MatchViewSection = new Enum({
  Info: 'info',
  Team: 'teams',
  Scorecard: 'scorecard',
  Stats: 'stats',
  Commentary: 'commentary',
  Fantasy: 'fantasy'
  // Game: 'game'
  // Live: 'live',
})

const FetchMethod = new Enum({
  Pull: 'Pull',
  Firebase: 'Sync',
  Pause: 'Pause',
  Socket02: 'Socket 02'
})

export default {
  name: 'match',
  props: {
    isMetric: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'MatchCommentary': MatchCommentary,
    'MatchFantasy': MatchFantasy,
    'MatchLive': MatchLive
    // 'FantasyGame': Fantasy
  },
  data () {
    return {
      matchKey: this.$route.params.key,
      match: null,
      oldSnapshot: {},
      selectedPlayer: null,
      selectedBall: null,
      pushId: null,
      pullId: null,
      socket02PushId: null,
      liveUpdateInited: false,
      renderComponent: true,

      fetchMethods: [FetchMethod.Pull, FetchMethod.Firebase, FetchMethod.Socket02, FetchMethod.Pause],
      fetchMethod: LocalUserPref.fetchMethod(FetchMethod.Pull.key),
      pullFreq: 5,
      state: DataState.newLoading(),

      activeSection: MatchViewSection.Info,
      sections: [], // ['Info', 'Team', 'Timeline', 'Stats'],

      matchUserPref: { activeInnings: 0, userSelected: false }
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.key !== from.params.key) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    },

    'fetchMethod' (to, from) {
      if (to === FetchMethod.Pull.key) {
        this.stopPush()
        this.stopSocket02Push()
        this.startPull()
      } else if (to === FetchMethod.Firebase.key) {
        this.stopPull()
        this.stopSocket02Push()
        this.startPush()
      } else if (to === FetchMethod.Socket02.key) {
        this.stopPush()
        this.stopPull()
        this.startSocket02Push()
      } else {
        this.stopPush()
        this.stopPull()
        this.stopSocket02Push()
      }

      LocalUserPref.updateFetchMethod(to)
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  created () {
    console.log(this.liveUpdateInited)
    this.$globalEvents.$on(AppEvents.fantasyCreateTeamVisible, this.onCreateTeamVisible)
    this.$globalEvents.$on(AppEvents.fantasyCreateTeamDone, this.onFantasyParticipated)
    this.$globalEvents.$on(AppEvents.fantasyResigned, this.onFantasyParticipated)
  },
  destroyed () {
    this.$globalEvents.$off(AppEvents.fantasyCreateTeamVisible, this.onCreateTeamVisible)
    this.$globalEvents.$off(AppEvents.fantasyCreateTeamDone, this.onFantasyParticipated)
    this.$globalEvents.$off(AppEvents.fantasyResigned, this.onFantasyParticipated)
    this.stopPush()
    this.stopPull()
    this.stopSocket02Push()
  },
  methods: {
    onViewOpenned () {
      this.matchKey = this.$route.params.key
      const newTitle = 'loading...'
      AppState.updateActivePage(`cricket_match_${this.matchKey}`)
      AppState.updateTitles(newTitle, newTitle)

      CricketMatch.fetch(this.matchKey, null, this.isMetric).then(match => {
        this.onMatchUpdated(match)
        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },
    prepareToReopen () {
      this.match = null
      this.oldSnapshot = {}
      this.pushId = null
      this.pullId = null
      this.socket02PushId = null
      this.liveUpdateInited = false
      this.selectedPlayer = null
      this.selectedBall = null
    },
    refreshView () {

    },

    getPullInstace (freq) {
      const freshness = this.match.dataFreshness
      const delayed = !(freshness.isLive)
      return Pull.instance(delayed, freq)
    },

    getTitlePrefix (match) {
      let prefix = ''

      if (!match.status.isStarted || !match.now) { return prefix }

      if (match.now.runs_str) {
        prefix = `${match.teams[match.now.batting_team].short_name}: ${match.now.runs_str}`
      }

      if (match.now.req && match.now.req.balls) {
        prefix += ` (Req ${match.now.req.runs} from ${match.now.req.balls} balls)`
      }

      return prefix
    },

    onPlayerSelected (playerKey) {
      this.selectedPlayer = this.match.players[playerKey]
      this.selectedBall = null
    },

    onBallSelected (ball) {
      this.selectedBall = ball
    },

    onCreateTeamVisible () {
      this.activeSection = MatchViewSection.Fantasy
    },

    onFantasyParticipated () {
      console.log('Updating secion')
      // this.activeSection = MatchViewSection.Game
    },

    onMatchUpdated (match) {
      let requireBallUpdate = false
      let requireMatchUpdate = false
      if (this.oldSnapshot.now) {
        if (this.match.now.last_ball && this.oldSnapshot.now.last_ball) {
          const prevLastBall = this.match.now.last_ball
          const lastBall = this.oldSnapshot.now.last_ball
          if (prevLastBall && lastBall && prevLastBall.key !== lastBall.key) {
            requireBallUpdate = true
          }
        }

        if (parseInt(this.match.expires) > parseInt(this.oldSnapshot.expires)) {
          requireMatchUpdate = true
        }
      }

      this.match = match
      this.oldSnapshot.now = this.match.now
      this.oldSnapshot.expires = this.match.expires

      this.minuteLabel = this.match.minuteLabel
      let titlePrefix = this.getTitlePrefix(match)
      let newTitle = this.match.title

      if (titlePrefix) {
        newTitle = `${titlePrefix} - ${newTitle}`
      }
      AppState.updateTitles(newTitle, newTitle)

      if (this.match.requiresLiveUpdate && (!this.liveUpdateInited)) {
        this.liveUpdateInited = true

        if (this.fetchMethod === FetchMethod.Firebase.key) {
          this.startPush()
        } else if (this.fetchMethod === FetchMethod.Pull.key) {
          this.match.updateLatest(true, this.isMetric)
          this.startPull()
        } else if (this.fetchMethod === FetchMethod.Socket02.key) {
          this.startSocket02Push()
        }
      }

      let newSections = [MatchViewSection.Info]

      if (this.match.havePlayers) {
        newSections.push(MatchViewSection.Team)
        newSections.push(MatchViewSection.Fantasy)
        // newSections.push(MatchViewSection.Game)
        // this.activeSection = MatchViewSection.Team
      }
      // if (this.match.status.isStarted) {
      //   newSections.push(MatchViewSection.Live)
      //   this.activeSection = MatchViewSection.Live
      // } else if (this.activeSection.isLive) {
      //   // Removing a tab, make sure to change the active section
      //   this.activeSection = MatchViewSection.Info
      // }

      if ((!this.match.status.isNotStarted) && this.match.batting_order.length > 0) {
        newSections.push(MatchViewSection.Scorecard)
        newSections.push(MatchViewSection.Stats)
        if (!this.isMetric) {
          newSections.push(MatchViewSection.Commentary)
        }
        if (!this.matchUserPref.userSelected) {
          this.matchUserPref.activeInnings = this.match.batting_order.length - 1
        }
      }

      this.sections = newSections

      if (this.appState.breadcrumb.length === 0) {
        let menu = [
          { title: this.match.season.short_name,
            route: {
              name: 'tournament', params: { key: this.match.season.key }
            } } // ,
          // {title: this.match.info.round.name, route: {
          //   name: 'tournamentRound', params: {key: this.match.info.tournament.key, roundkey: this.match.info.round.key}
          // }}
        ]
        this.AppState.updateBreadcrumb(menu)
      }

      if (requireMatchUpdate) {
        this.$globalEvents.$emit(AppEvents.cricketMatchUpdate, match)
      }

      if (requireBallUpdate) {
        this.$globalEvents.$emit(AppEvents.cricketMatchBallUpdate, match)
      }
    },

    startPull () {
      // console.log('Listening update', this.matchKey)
      this.pullId = this.getPullInstace(this.pullFreq).listenUpdate(this.match.key, (updatedMatch) => {
        console.debug('Got Pull Update', this.matchKey, this.getTitlePrefix(updatedMatch))
        this.match.overwrite(updatedMatch)
        this.onMatchUpdated(this.match)
      }, CricketMatch.fetch, [this.match.key, true, this.isMetric])
    },

    startPush () {
      this.pushId = CricketFirebase.instance().listenMatch(this.match.key, (updatedMatch) => {
        console.debug('Got Firebase Update', this.matchKey, this.getTitlePrefix(updatedMatch))
        // console.log(updatedMatch)
        this.match.overwrite(updatedMatch)
        this.onMatchUpdated(this.match)
      })
    },

    startSocket02Push () {
      this.socket02PushId = SocketProxy.instance().listenMatch(this.match.key, (updatedMatch) => {
        console.debug('Got Socket Update', this.matchKey, this.getTitlePrefix(updatedMatch))
        this.match.overwrite(updatedMatch)
        this.onMatchUpdated(this.match)
      })
    },

    stopPull () {
      if (this.pullId) {
        this.getPullInstace(this.pullFreq).stopUpdate(this.matchKey, this.pullId)
      }
    },

    stopPush () {
      if (this.pushId) {
        CricketFirebase.instance().stopMatchUpdate(this.matchKey, this.pushId)
        this.pushId = null
        this.pushInited = false
      }
    },

    stopSocket02Push () {
      if (this.socket02PushId) {
        SocketProxy.instance().stopMatchUpdate(this.matchKey, this.socket02PushId)
      }
    }
  }
}
</script>
